import script from "./FlyoutMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlyoutMenu.vue?vue&type=script&setup=true&lang=ts"

import "./FlyoutMenu.vue?vue&type=style&index=0&id=b6498c04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6498c04"]])

export default __exports__